import React from 'react';
import Dialog from 'components/Dialogs/Dialog';
import { ActionDialogProps } from './ActionDialog.props';

const ActionDialog = ({ open, title, subtitle, children, handleDialogClose, paperSx }: ActionDialogProps) => (
  <Dialog
    title={title}
    subtitle={subtitle}
    open={open}
    onClose={handleDialogClose}
    PaperProps={{ sx: { width: '25vw', ...paperSx } }}>
    {children}
  </Dialog>
);

export default ActionDialog;
